

//USER
export const FETCH_USERS = 'FETCH_USERS';
export const FETCH_USER = 'FETCH_USER';
export const EDIT_USER = 'EDIT_USER';
export const DELETE_USER = 'DELETE_USER';
export const NEW_USER = 'NEW_USER';

//AUTH
export const FETCH_AUTHS = 'FETCH_AUTHS';
export const FETCH_AUTH = 'FETCH_AUTH';
export const EDIT_AUTH = 'EDIT_AUTH';
export const DELETE_AUTH = 'DELETE_AUTH';
export const NEW_AUTH = 'NEW_AUTH';
export const CHECK_AUTH = 'CHECK_AUTH;';
export const QUIT_AUTH ='QUIT_AUTH';

//PERMISSION
export const FETCH_USERPERMISSIONS = 'FETCH_USERPERMISSIONS';
export const FETCH_PATIENTPERMISSIONS = 'FETCH_PATIENTPERMISSIONS';
export const FETCH_PERMISSION = 'FETCH_PERMISSION';
export const EDIT_PERMISSION = 'EDIT_PERMISSION';
export const DELETE_PERMISSION = 'DELETE_PERMISSION';
export const NEW_PERMISSION = 'NEW_PERMISSION';



//Biodata
export const FETCH_PATIENTS = 'FETCH_PATIENTS';
export const FETCH_PATIENT = 'FETCH_PATIENT';
export const EDIT_PATIENT = 'EDIT_PATIENT';
export const DELETE_PATIENT = 'DELETE_PATIENT';
export const NEW_PATIENT = 'NEW_PATIENT';
export const SELECTED_PATIENT = 'SELECT_PATIENT';
export const CLEAR_PATIENT = 'CLEAR_PATIENT';

//Vaccinations
export const FETCH_VACCINATIONS = 'FETCH_VACCINATIONS';
export const FETCH_VACCINATION = 'FETCH_VACCINATION';
export const EDIT_VACCINATION = 'EDIT_VACCINATION';
export const DELETE_VACCINATION = 'DELETE_VACCINATION';
export const NEW_VACCINATION = 'NEW_VACCINATION';

//Medications
export const FETCH_MEDICATIONS = 'FETCH_MEDICATIONS';
export const FETCH_MEDICATION = 'FETCH_MEDICATION';
export const EDIT_MEDICATION = 'EDIT_MEDICATION';
export const DELETE_MEDICATION = 'DELETE_MEDICATION';
export const NEW_MEDICATION = 'NEW_MEDICATION';

//Todo
export const FETCH_TODOS = 'FETCH_TODOS';
export const FETCH_TODO = 'FETCH_TODO';
export const EDIT_TODO = 'EDIT_TODO';
export const DELETE_TODO = 'DELETE_TODO';
export const NEW_TODO = 'NEW_TODO';

//History
export const FETCH_HISTORIES = 'FETCH_HISTORIES';
export const FETCH_HISTORY = 'FETCH_HISTORY';
export const EDIT_HISTORY = 'EDIT_HISTORY';
export const DELETE_HISTORY = 'DELETE_HISTORY';
export const NEW_HISTORY = 'NEW_HISTORY';

//Other Detail
export const FETCH_OTHERDETAILS = 'FETCH_OTHERDETAILS';
export const FETCH_OTHERDETAIL = 'FETCH_OTHERDETAIL';
export const EDIT_OTHERDETAIL = 'EDIT_OTHERDETAIL';
export const DELETE_OTHERDETAIL = 'DELETE_OTHERDETAIL';
export const NEW_OTHERDETAIL = 'NEW_OTHERDETAIL';

// Preventive Plan
export const FETCH_PREVENTIVES = 'FETCH_PREVENTIVES';
export const FETCH_PREVENTIVE = 'FETCH_PREVENTIVE';
export const EDIT_PREVENTIVE = 'EDIT_PREVENTIVE';
export const DELETE_PREVENTIVE = 'DELETE_PREVENTIVE';
export const NEW_PREVENTIVE = 'NEW_PREVENTIVE';

//Health Assessment Details
export const FETCH_HA_DETAILS = 'FETCH_HA_DETAILS';
export const FETCH_HA_DETAIL = 'FETCH_HA_DETAIL';
export const EDIT_HA_DETAIL = 'EDIT_HA_DETAIL';
export const DELETE_HA_DETAIL = 'DELETE_HA_DETAIL';
export const NEW_HA_DETAIL = 'NEW_HA_DETAIL';

//Health Assessment Examination
export const FETCH_HA_EXAMS = 'FETCH_HA_EXAMS';
export const FETCH_HA_EXAM = 'FETCH_HA_EXAM';
export const EDIT_HA_EXAM = 'EDIT_HA_EXAM';
export const DELETE_HA_EXAM = 'DELETE_HA_EXAM';
export const NEW_HA_EXAM = 'NEW_HA_EXAM';

//Reminder
export const FETCH_REMINDERS = 'FETCH_REMINDERS';
export const FETCH_REMINDER = 'FETCH_REMINDER';
export const EDIT_REMINDER = 'EDIT_REMINDER';
export const DELETE_REMINDER = 'DELETE_REMINDER';
export const NEW_REMINDER = 'NEW_REMINDER';

//Reaction
export const FETCH_REACTIONS = 'FETCH_REACTIONS';
export const FETCH_REACTION = 'FETCH_REACTION';
export const EDIT_REACTION = 'EDIT_REACTION';
export const DELETE_REACTION = 'DELETE_REACTION';
export const NEW_REACTION = 'NEW_REACTION';

//Request
export const FETCH_REQUESTPATHS = 'FETCH_REQUESTPATHS';
export const FETCH_REQUESTPATH = 'FETCH_REQUESTPATH';
export const EDIT_REQUESTPATH = 'EDIT_REQUESTPATH';
export const DELETE_REQUESTPATH = 'DELETE_REQUESTPATH';
export const NEW_REQUESTPATH = 'NEW_REQUESTPATH';

//visit
export const FETCH_VISITS = 'FETCH_VISITS';
export const FETCH_VISIT = 'FETCH_VISIT';
export const EDIT_VISIT = 'EDIT_VISIT';
export const DELETE_VISIT = 'DELETE_VISIT';
export const NEW_VISIT = 'NEW_VISIT';

//Prescription
export const FETCH_PRESCRIPTIONS = 'FETCH_PRESCRIPTIONS';
export const FETCH_PRESCRIPTION = 'FETCH_PRESCRIPTION';
export const EDIT_PRESCRIPTION = 'EDIT_PRESCRIPTION';
export const DELETE_PRESCRIPTION = 'DELETE_PRESCRIPTION';
export const NEW_PRESCRIPTION = 'NEW_PRESCRIPTION';

//Family history
export const FETCH_FAMILYHISTORIES = 'FETCH_FAMILYHISTORIES';
export const FETCH_FAMILYHISTORY = 'FETCH_FAMILYHISTORY';
export const EDIT_FAMILYHISTORY = 'EDIT_FAMILYHISTORY';
export const DELETE_FAMILYHISTORY = 'DELETE_FAMILYHISTORY';
export const NEW_FAMILYHISTORY = 'NEW_FAMILYHISTORY';

//DISEASE LIBRARY
export const FETCH_DISEASELIBS = 'FETCH_DISEASELIBS';
export const FETCH_DISEASELIB = 'FETCH_DISEASELIB';
export const EDIT_DISEASELIB = 'EDIT_DISEASELIB';
export const DELETE_DISEASELIB = 'DELETE_DISEASELIB';
export const NEW_DISEASELIB = 'NEW_DISEASELIB';

//ARRANGE LIBRARY
export const FETCH_ARRANGELIBS = 'FETCH_ARRANGELIBS';
export const FETCH_ARRANGELIB = 'FETCH_ARRANGELIB';
export const EDIT_ARRANGELIB = 'EDIT_ARRANGELIB';
export const DELETE_ARRANGELIB = 'DELETE_ARRANGELIB';
export const NEW_ARRANGELIB = 'NEW_ARRANGELIB';

//GOAL LIBRARY
export const FETCH_GOALLIBS = 'FETCH_GOALLIBS';
export const FETCH_GOALLIB = 'FETCH_GOALLIB';
export const EDIT_GOALLIB = 'EDIT_GOALLIB';
export const DELETE_GOALLIB = 'DELETE_GOALLIB';
export const NEW_GOALLIB = 'NEW_GOALLIB';

//MONITOR LIBRARY
export const FETCH_MONITORLIBS = 'FETCH_MONITORLIBS';
export const FETCH_MONITORLIB = 'FETCH_MONITORLIB';
export const EDIT_MONITORLIB = 'EDIT_MONITORLIB';
export const DELETE_MONITORLIB = 'DELETE_MONITORLIB';
export const NEW_MONITORLIB = 'NEW_MONITORLIB';

//EDUCATION LIBRARY
export const FETCH_EDUCATIONLIBS = 'FETCH_EDUCATIONLIBS';
export const FETCH_EDUCATIONLIB = 'FETCH_EDUCATIONLIB';
export const EDIT_EDUCATIONLIB = 'EDIT_EDUCATIONLIB';
export const DELETE_EDUCATIONLIB = 'DELETE_EDUCATIONLIB';
export const NEW_EDUCATIONLIB = 'NEW_EDUCATIONLIB';

//PROBLEM
export const FETCH_PROBLEMS = 'FETCH_PROBLEMS';
export const FETCH_PROBLEM = 'FETCH_PROBLEM';
export const EDIT_PROBLEM = 'EDIT_PROBLEM';
export const DELETE_PROBLEM = 'DELETE_PROBLEM';
export const NEW_PROBLEM = 'NEW_PROBLEM';

//GOAL
export const FETCH_GOALS = 'FETCH_GOALS';
export const FETCH_GOAL = 'FETCH_GOAL';
export const EDIT_GOAL = 'EDIT_GOAL';
export const DELETE_GOAL = 'DELETE_GOAL';
export const NEW_GOAL = 'NEW_GOAL';

//ARRANGE
export const FETCH_ARRANGES = 'FETCH_ARRANGES';
export const FETCH_ARRANGE = 'FETCH_ARRANGE';
export const EDIT_ARRANGE = 'EDIT_ARRANGE';
export const DELETE_ARRANGE = 'DELETE_ARRANGE';
export const NEW_ARRANGE = 'NEW_ARRANGE';

//EDUCATION
export const FETCH_EDUCATIONS = 'FETCH_EDUCATIONS';
export const FETCH_EDUCATION = 'FETCH_EDUCATION';
export const EDIT_EDUCATION = 'EDIT_EDUCATION';
export const DELETE_EDUCATION = 'DELETE_EDUCATION';
export const NEW_EDUCATION = 'NEW_EDUCATION';

//MONITOR
export const FETCH_MONITORS = 'FETCH_MONITORS';
export const FETCH_MONITOR = 'FETCH_MONITOR';
export const EDIT_MONITOR = 'EDIT_MONITOR';
export const DELETE_MONITOR = 'DELETE_MONITOR';
export const NEW_MONITOR = 'NEW_MONITOR';


//AODHISTORY
export const FETCH_AODHISTORYS = 'FETCH_AODHISTORYS';
export const FETCH_AODHISTORY = 'FETCH_AODHISTORY';
export const EDIT_AODHISTORY = 'EDIT_AODHISTORY';
export const DELETE_AODHISTORY = 'DELETE_AODHISTORY';
export const NEW_AODHISTORY = 'NEW_AODHISTORY';

//AODLEGAL
export const FETCH_AODLEGALS = 'FETCH_AODLEGALS';
export const FETCH_AODLEGAL = 'FETCH_AODLEGAL';
export const EDIT_AODLEGAL = 'EDIT_AODLEGAL';
export const DELETE_AODLEGAL = 'DELETE_AODLEGAL';
export const NEW_AODLEGAL = 'NEW_AODLEGAL';

//AODPLAN
export const FETCH_AODPLANS = 'FETCH_AODPLANS';
export const FETCH_AODPLAN = 'FETCH_AODPLAN';
export const EDIT_AODPLAN = 'EDIT_AODPLAN';
export const DELETE_AODPLAN = 'DELETE_AODPLAN';
export const NEW_AODPLAN = 'NEW_AODPLAN';

//AODSUBSTANCE
export const FETCH_AODSUBSTANCES = 'FETCH_AODSUBSTANCES';
export const FETCH_AODSUBSTANCE = 'FETCH_AODSUBSTANCE';
export const EDIT_AODSUBSTANCE = 'EDIT_AODSUBSTANCE';
export const DELETE_AODSUBSTANCE = 'DELETE_AODSUBSTANCE';
export const NEW_AODSUBSTANCE = 'NEW_AODSUBSTANCE';

//IMAGEEPISODE
export const FETCH_IMAGEEPISODES = 'FETCH_IMAGEEPISODES';
export const FETCH_IMAGEEPISODE = 'FETCH_IMAGEEPISODE';
export const EDIT_IMAGEEPISODE = 'EDIT_IMAGEEPISODE';
export const DELETE_IMAGEEPISODE = 'DELETE_IMAGEEPISODE';
export const NEW_IMAGEEPISODE = 'NEW_IMAGEEPISODE';

//IMAGEPHOTO
export const FETCH_IMAGEPHOTOS = 'FETCH_IMAGEPHOTOS';
export const FETCH_IMAGEPHOTO = 'FETCH_IMAGEPHOTO';
export const EDIT_IMAGEPHOTO = 'EDIT_IMAGEPHOTO';
export const DELETE_IMAGEPHOTO = 'DELETE_IMAGEPHOTO';
export const NEW_IMAGEPHOTO = 'NEW_IMAGEPHOTO';

//MHACTION
export const FETCH_MHACTIONS = 'FETCH_MHACTIONS';
export const FETCH_MHACTION = 'FETCH_MHACTION';
export const EDIT_MHACTION = 'EDIT_MHACTION';
export const DELETE_MHACTION = 'DELETE_MHACTION';
export const NEW_MHACTION = 'NEW_MHACTION';

//MHFORMULATE
export const FETCH_MHFORMULATES = 'FETCH_MHFORMULATES';
export const FETCH_MHFORMULATE = 'FETCH_MHFORMULATE';
export const EDIT_MHFORMULATE = 'EDIT_MHFORMULATE';
export const DELETE_MHFORMULATE = 'DELETE_MHFORMULATE';
export const NEW_MHFORMULATE = 'NEW_MHFORMULATE';

//MHPROFILE
export const FETCH_MHPROFILES = 'FETCH_MHPROFILES';
export const FETCH_MHPROFILE = 'FETCH_MHPROFILE';
export const EDIT_MHPROFILE = 'EDIT_MHPROFILE';
export const DELETE_MHPROFILE = 'DELETE_MHPROFILE';
export const NEW_MHPROFILE = 'NEW_MHPROFILE';

//MHPROVIDER
export const FETCH_MHPROVIDERS = 'FETCH_MHPROVIDERS';
export const FETCH_MHPROVIDER = 'FETCH_MHPROVIDER';
export const EDIT_MHPROVIDER = 'EDIT_MHPROVIDER';
export const DELETE_MHPROVIDER = 'DELETE_MHPROVIDER';
export const NEW_MHPROVIDER = 'NEW_MHPROVIDER';

//MHREVIEW
export const FETCH_MHREVIEWS = 'FETCH_MHREVIEWS';
export const FETCH_MHREVIEW = 'FETCH_MHREVIEW';
export const EDIT_MHREVIEW = 'EDIT_MHREVIEW';
export const DELETE_MHREVIEW = 'DELETE_MHREVIEW';
export const NEW_MHREVIEW = 'NEW_MHREVIEW';

//MHSAFETY
export const FETCH_MHSAFETYS = 'FETCH_MHSAFETYS';
export const FETCH_MHSAFETY = 'FETCH_MHSAFETY';
export const EDIT_MHSAFETY = 'EDIT_MHSAFETY';
export const DELETE_MHSAFETY = 'DELETE_MHSAFETY';
export const NEW_MHSAFETY = 'NEW_MHSAFETY';

//PAINEXAMINATION
export const FETCH_PAINEXAMINATIONS = 'FETCH_PAINEXAMINATIONS';
export const FETCH_PAINEXAMINATION = 'FETCH_PAINEXAMINATION';
export const EDIT_PAINEXAMINATION = 'EDIT_PAINEXAMINATION';
export const DELETE_PAINEXAMINATION = 'DELETE_PAINEXAMINATION';
export const NEW_PAINEXAMINATION = 'NEW_PAINEXAMINATION';

//PAINHISTORY
export const FETCH_PAINHISTORYS = 'FETCH_PAINHISTORYS';
export const FETCH_PAINHISTORY = 'FETCH_PAINHISTORY';
export const EDIT_PAINHISTORY = 'EDIT_PAINHISTORY';
export const DELETE_PAINHISTORY = 'DELETE_PAINHISTORY';
export const NEW_PAINHISTORY = 'NEW_PAINHISTORY';

//PAINPSYCHOSOCIAL
export const FETCH_PAINPSYCHOSOCIALS = 'FETCH_PAINPSYCHOSOCIALS';
export const FETCH_PAINPSYCHOSOCIAL = 'FETCH_PAINPSYCHOSOCIAL';
export const EDIT_PAINPSYCHOSOCIAL = 'EDIT_PAINPSYCHOSOCIAL';
export const DELETE_PAINPSYCHOSOCIAL = 'DELETE_PAINPSYCHOSOCIAL';
export const NEW_PAINPSYCHOSOCIAL = 'NEW_PAINPSYCHOSOCIAL';

//PAINREVIEW
export const FETCH_PAINREVIEWS = 'FETCH_PAINREVIEWS';
export const FETCH_PAINREVIEW = 'FETCH_PAINREVIEW';
export const EDIT_PAINREVIEW = 'EDIT_PAINREVIEW';
export const DELETE_PAINREVIEW = 'DELETE_PAINREVIEW';
export const NEW_PAINREVIEW = 'NEW_PAINREVIEW';

//PAINTREATMENT
export const FETCH_PAINTREATMENTS = 'FETCH_PAINTREATMENTS';
export const FETCH_PAINTREATMENT = 'FETCH_PAINTREATMENT';
export const EDIT_PAINTREATMENT = 'EDIT_PAINTREATMENT';
export const DELETE_PAINTREATMENT = 'DELETE_PAINTREATMENT';
export const NEW_PAINTREATMENT = 'NEW_PAINTREATMENT';

//OBSERVATION
export const FETCH_OBSERVATIONS = 'FETCH_OBSERVATIONS';
export const FETCH_OBSERVATION = 'FETCH_OBSERVATION';
export const EDIT_OBSERVATION = 'EDIT_OBSERVATION';
export const DELETE_OBSERVATION = 'DELETE_OBSERVATION';
export const NEW_OBSERVATION = 'NEW_OBSERVATION';

//PATHOLOGY
export const FETCH_PATHOLOGYS = 'FETCH_PATHOLOGYS';
export const FETCH_PATHOLOGY = 'FETCH_PATHOLOGY';
export const EDIT_PATHOLOGY = 'EDIT_PATHOLOGY';
export const DELETE_PATHOLOGY = 'DELETE_PATHOLOGY';
export const NEW_PATHOLOGY = 'NEW_PATHOLOGY';

//HOMECHECK
export const FETCH_HOMECHECKS = 'FETCH_HOMECHECKS';
export const FETCH_HOMECHECK = 'FETCH_HOMECHECK';
export const EDIT_HOMECHECK = 'EDIT_HOMECHECK';
export const DELETE_HOMECHECK = 'DELETE_HOMECHECK';
export const NEW_HOMECHECK = 'NEW_HOMECHECK';

//HOMEGLUCOSE
export const FETCH_HOMEGLUCOSES = 'FETCH_HOMEGLUCOSES';
export const FETCH_HOMEGLUCOSE = 'FETCH_HOMEGLUCOSE';
export const EDIT_HOMEGLUCOSE = 'EDIT_HOMEGLUCOSE';
export const DELETE_HOMEGLUCOSE = 'DELETE_HOMEGLUCOSE';
export const NEW_HOMEGLUCOSE = 'NEW_HOMEGLUCOSE';

//HOMEWEIGHT
export const FETCH_HOMEWEIGHTS = 'FETCH_HOMEWEIGHTS';
export const FETCH_HOMEWEIGHT = 'FETCH_HOMEWEIGHT';
export const EDIT_HOMEWEIGHT = 'EDIT_HOMEWEIGHT';
export const DELETE_HOMEWEIGHT = 'DELETE_HOMEWEIGHT';
export const NEW_HOMEWEIGHT = 'NEW_HOMEWEIGHT';

//HOMEBP
export const FETCH_HOMEBPS = 'FETCH_HOMEBPS';
export const FETCH_HOMEBP = 'FETCH_HOMEBP';
export const EDIT_HOMEBP = 'EDIT_HOMEBP';
export const DELETE_HOMEBP = 'DELETE_HOMEBP';
export const NEW_HOMEBP = 'NEW_HOMEBP';

//FLAG
export const FETCH_FLAGS = 'FETCH_FLAGS';
export const FETCH_FLAG = 'FETCH_FLAG';
export const EDIT_FLAG = 'EDIT_FLAG';
export const DELETE_FLAG = 'DELETE_FLAG';
export const NEW_FLAG = 'NEW_FLAG';

//PHOTOEXTERNAL
export const FETCH_PHOTOEXTERNALS = 'FETCH_PHOTOEXTERNALS';
export const FETCH_PHOTOEXTERNAL = 'FETCH_PHOTOEXTERNAL';
export const EDIT_PHOTOEXTERNAL = 'EDIT_PHOTOEXTERNAL';
export const DELETE_PHOTOEXTERNAL = 'DELETE_PHOTOEXTERNAL';
export const NEW_PHOTOEXTERNAL = 'NEW_PHOTOEXTERNAL';


//PHOTOMACRO
export const FETCH_PHOTOMACROS = 'FETCH_PHOTOMACROS';
export const FETCH_PHOTOMACRO = 'FETCH_PHOTOMACRO';
export const EDIT_PHOTOMACRO = 'EDIT_PHOTOMACRO';
export const DELETE_PHOTOMACRO = 'DELETE_PHOTOMACRO';
export const NEW_PHOTOMACRO = 'NEW_PHOTOMACRO';
export const FETCH_SHOWMACRO = 'FETCH_SHOWMACRO';

//PHOTODERMOSCOPY
export const FETCH_PHOTODERMOSCOPYS = 'FETCH_PHOTODERMOSCOPYS';
export const FETCH_PHOTODERMOSCOPY = 'FETCH_PHOTODERMOSCOPY';
export const EDIT_PHOTODERMOSCOPY = 'EDIT_PHOTODERMOSCOPY';
export const DELETE_PHOTODERMOSCOPY = 'DELETE_PHOTODERMOSCOPY';
export const NEW_PHOTODERMOSCOPY = 'NEW_PHOTODERMOSCOPY';

//PHOTODISPLAY
export const FETCH_PHOTODISPLAYS = 'FETCH_PHOTODISPLAYS';
export const FETCH_PHOTODISPLAY = 'FETCH_PHOTODISPLAY';
export const EDIT_PHOTODISPLAY = 'EDIT_PHOTODISPLAY';
export const DELETE_PHOTODISPLAY = 'DELETE_PHOTODISPLAY';
export const NEW_PHOTODISPLAY = 'NEW_PHOTODISPLAY';

//SHOWDERMOSCOPY
export const FETCH_SHOWDERMOSCOPYS = 'FETCH_SHOWDERMOSCOPYS';
export const FETCH_SHOWDERMOSCOPY = 'FETCH_SHOWDERMOSCOPY';
export const EDIT_SHOWDERMOSCOPY = 'EDIT_SHOWDERMOSCOPY';
export const DELETE_SHOWDERMOSCOPY = 'DELETE_SHOWDERMOSCOPY';
export const NEW_SHOWDERMOSCOPY = 'NEW_SHOWDERMOSCOPY';

//ANALYTIC
export const FETCH_WARNING = 'FETCH_WARNING';
export const FETCH_DUE = 'FETCH_DUE';